import { render, staticRenderFns } from "./carousel.vue?vue&type=template&id=24f26fa4&"
import script from "./carousel.vue.ts?vue&type=script&lang=ts&"
export * from "./carousel.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports